export default "__VITE_ASSET__BILHyw4i__"